import { CheckCircle2, AlertTriangle, XCircle, Lightbulb } from 'lucide-react';
import type { RunInterpretation } from '@/services/perfTestsApi';

const VERDICT_STYLES: Record<RunInterpretation['verdict'], {
  bg: string; border: string; text: string; Icon: typeof CheckCircle2; label: string;
}> = {
  PASS: {
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
    text: 'text-emerald-900',
    Icon: CheckCircle2,
    label: 'Conforme',
  },
  WARN: {
    bg: 'bg-amber-50',
    border: 'border-amber-200',
    text: 'text-amber-900',
    Icon: AlertTriangle,
    label: 'À surveiller',
  },
  FAIL: {
    bg: 'bg-red-50',
    border: 'border-red-200',
    text: 'text-red-900',
    Icon: XCircle,
    label: 'À corriger',
  },
};

export function RunInterpretationPanel({ interpretation }: { interpretation: RunInterpretation }) {
  const style = VERDICT_STYLES[interpretation.verdict];
  const { Icon } = style;
  return (
    <div className={`border rounded-md p-3 ${style.bg} ${style.border}`}>
      <div className={`flex items-start gap-2 ${style.text}`}>
        <Icon className="w-5 h-5 flex-shrink-0 mt-0.5" />
        <div className="min-w-0 flex-1">
          <div className="text-xs font-medium uppercase tracking-wide opacity-70">
            {style.label}
          </div>
          <div className="text-sm font-medium mt-0.5">{interpretation.headline}</div>
        </div>
      </div>

      {interpretation.insights.length > 0 && (
        <ul className={`mt-3 space-y-1 text-xs ${style.text}`}>
          {interpretation.insights.map((insight, i) => (
            <li key={i} className="flex gap-2">
              <span className="opacity-60">•</span>
              <span>{insight}</span>
            </li>
          ))}
        </ul>
      )}

      {interpretation.suggestedActions.length > 0 && (
        <div className="mt-3 pt-3 border-t border-current/20">
          <div className={`flex items-center gap-1 text-xs font-medium ${style.text} opacity-80 mb-1`}>
            <Lightbulb className="w-3 h-3" />
            Actions suggérées
          </div>
          <ul className="space-y-1 text-xs text-gray-700">
            {interpretation.suggestedActions.map((action, i) => (
              <li key={i} className="flex gap-2">
                <span className="opacity-60">→</span>
                <span>{action}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
